import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';

import configureStore from './store/configure';
import Page from './page';

let store;

export default function ShadowsIndex({ setDirty, selectedShadow, selectShadow, ...initialState }) {
  store = useRef(configureStore(initialState));

  return (
    <Provider store={store.current}>
      <Page 
        selectedGlobalShadow={selectedShadow} 
        selectGlobalShadow={selectShadow} 
        setDirty={setDirty} 
      />
    </Provider>
  );
}

ShadowsIndex.propTypes = {
  selectedShadow: PropTypes.object,
  selectShadow: PropTypes.func,
  setDirty: PropTypes.func,
};
